<nb-layout [ngClass]="isShowBlock === true ? 'fix-menu' : ''">

  <nb-sidebar [state]="sideBarState" *ngIf="loaded">

      <a href="/" class="logo-small">
        <img src="/assets/images/new_logo_small.svg" alt="">
      </a>
      <a href="/" class="logo">
        <img src="/assets/images/new_logo.svg" alt="">
      </a>

      <div (click)="toggleSidebar()" class="sidebar-toggle" [ngClass]="isShowBlock === true ? 'checkedHeader' : 'uncheckedHeader'">
        <img class="menu-close" src="/assets/images/header/menu-close.svg" alt="">
        <img class="menu-open" src="/assets/images/menu-s.svg" alt="">
      </div>

      <div class="search">
        <input *ngIf="isShowBlock && menuItems?.length"
               i18n-placeholder="@@Search" [formControl]="inputFormControl"
               nbInput
               class="search"
               type="text"
               fullWidth fieldSize="small"
               placeholder="Поиск"
               [nbAutocomplete]="auto"
               #searchInput
        />
        <span class="keys">
        <kbd *ngIf="isMac" style="font-size: 16px">⌘</kbd>
        <kbd *ngIf="!isMac">Ctrl</kbd>
        <kbd>K</kbd>
      </span>

        <nb-autocomplete #auto [size]="'small'">
          <nb-option *ngFor="let item of searchMatches" [value]="item" class="search-match">
            <div *ngIf="item.hasOwnProperty('parent')" class="search-match-parent-title"> {{ item.parent.title }}</div>
            <div class="search-match-title"> {{ item.title }}</div>
          </nb-option>
        </nb-autocomplete>
      </div>

      <nb-menu *ngIf="isShowBlock && menuItems?.length" [items]="menuItems"></nb-menu>
      <app-compact-menu *ngIf="isShowMenu  && menuItems?.length" [items]="menuItems"></app-compact-menu>

      <div class="menu-bottom-show">
        <div *ngIf="customer" [routerLink]="['cabinet', 'profile']">
          <img *ngIf="avatarImage && avatarImage" class="menu-close" [src]="avatarImage" alt="">
          <nb-icon *ngIf="!avatarImage" icon="person-outline"></nb-icon>
          <p title="{{customer.firstName+' '+customer.lastName}}">{{ customer.firstName + ' ' + customer.lastName }}</p>
        </div>
        <div (click)="logout()">
          <nb-icon *ngIf="!avatarImage" icon="log-out"></nb-icon>
          <p>Выход</p>
        </div>
      </div>

    <div class="menu-bottom-small">
      <div [routerLink]="['cabinet', 'profile']">
        <img *ngIf="avatarImage!== null && avatarImage" class="menu-close" [src]="avatarImage" alt="">
        <nb-icon *ngIf="!avatarImage" icon="person-outline"></nb-icon>
      </div>
      <div (click)="logout()">
        <nb-icon *ngIf="!avatarImage" icon="log-out"></nb-icon>
      </div>
    </div>


  </nb-sidebar>
  <nb-layout-column>
    <app-state-topline></app-state-topline>
    <router-outlet *ngIf="loaded"></router-outlet>
  </nb-layout-column>
</nb-layout>
